import { useEffect, useState } from 'react';
import expandIcon from '../../public/images/expand-solid.svg';
import compressIcon from '../../public/images/compress-solid.svg';

const expandIconAlt = 'Enter Fullscreen';
const compressIconAlt = 'Exit Fullscreen';

export function FullScreenButton() {
  const [fullscreenAvailable, setFullscreenAvailable] = useState(false);
  const [icon, setIcon] = useState(expandIcon);
  const [iconAlt, setIconAlt] = useState(expandIconAlt);

  const updateIconAndAlt = () => {
    const isInFullscreen = (document.fullscreenElement || document.webkitFullscreenElement) != null;
    setIcon(isInFullscreen ? compressIcon : expandIcon);
    setIconAlt(isInFullscreen ? compressIconAlt : expandIconAlt);
  };

  useEffect(() => {
    const available =
      typeof document.documentElement.requestFullscreen === 'function' ||
      typeof document.documentElement.webkitRequestFullscreen === 'function';
    setFullscreenAvailable(available);

    // Add listener for Escape key or other ways to exit fullscreen
    document.addEventListener('fullscreenchange', updateIconAndAlt);
    document.addEventListener('webkitfullscreenchange', updateIconAndAlt);

    // Cleanup listeners
    return () => {
      document.removeEventListener('fullscreenchange', updateIconAndAlt);
      document.removeEventListener('webkitfullscreenchange', updateIconAndAlt);
    };
  }, []);

  const handleFullscreenToggle = () => {
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    } else {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    }
    // No need to manually call updateIconAndAlt here, 
    // the event listener will catch the change automatically.
  };

  return fullscreenAvailable ? (
    <div className="button fullscreen-button" onClick={handleFullscreenToggle}>
      <img src={icon} alt={iconAlt} />
    </div>
  ) : null;
}